export default __webpack_public_path__ + "static/runn-2e140a3dee179abf7ba897f156539642.svg";